export default __webpack_public_path__ + "static/media/others8.f03261c2.jpg";